import {
  LazyLoadImage,
  LazyLoadImageProps,
} from "react-lazy-load-image-component";
import { styled, EmotionComponent } from "../../styled";
import {
  space,
  layout,
  SpaceProps,
  LayoutProps,
  compose,
  OverrideNativeElementProps,
} from "../../utils/styleFn";

const styleProps = compose(space, layout);

type StyleProps = SpaceProps & LayoutProps;
export type ImageProps = OverrideNativeElementProps<StyleProps, "img">;

const style = `
  display: block;
  width: 100%;
  height: auto;
`;

// represents basic HTML img tag
export const Image: EmotionComponent<ImageProps> = styled.img`
  ${style}
  ${styleProps}
`;

// lazy loaded image
export const ImageLazy: EmotionComponent<
  ImageProps & LazyLoadImageProps
> = styled(LazyLoadImage)`
  ${style}
  ${styleProps}
`;

export default Image;
